module.exports = __webpack_public_path__ + "media/assets/faria_products/PEA-ADV-54be0759dffa6012e5c5993d33f831fd60adf3357c5aeeb388c3debd2c3372b9.svg";